(function () {
  'use strict';

  // ─── FadeUp on scroll ───────────────────────────────────────────────
  function initFadeUp() {
    var els = document.querySelectorAll('[data-fade-up]');
    if (!('IntersectionObserver' in window) || els.length === 0) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.getAttribute('data-fade-up-delay') || '0', 10);
          if (delay > 0) {
            entry.target.style.transitionDelay = (delay / 1000) + 's';
          }
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });
  }

  // ─── Sticky header ───────────────────────────────────────────────────
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ─── Mobile menu ─────────────────────────────────────────────────────
  function initMobileMenu() {
    var btn = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () {
      var open = btn.classList.toggle('is-open');
      menu.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    // Close on link tap
    menu.querySelectorAll('a, button').forEach(function (link) {
      link.addEventListener('click', function () {
        btn.classList.remove('is-open');
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // ─── FAQ accordions ──────────────────────────────────────────────────
  function initFaqAccordions() {
    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-faq-trigger]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        // Close siblings within the same group (data-faq-group)
        var group = item.closest('[data-faq-group]');
        if (group) {
          group.querySelectorAll('[data-faq-item]').forEach(function (sibling) {
            if (sibling !== item) sibling.classList.remove('is-open');
          });
        }
        item.classList.toggle('is-open');
      });
    });
  }

  // ─── Tab filters (Shop, Journal, FAQ) ────────────────────────────────
  function initTabs() {
    document.querySelectorAll('[data-tab-group]').forEach(function (group) {
      var triggers = group.querySelectorAll('[data-tab-trigger]');
      var panels = document.querySelectorAll('[data-tab-panel][data-tab-for="' + group.getAttribute('data-tab-group') + '"]');
      var items = document.querySelectorAll('[data-tab-item][data-tab-for="' + group.getAttribute('data-tab-group') + '"]');
      triggers.forEach(function (trig) {
        trig.addEventListener('click', function () {
          var key = trig.getAttribute('data-tab-trigger');
          triggers.forEach(function (t) { t.classList.toggle('is-active', t === trig); });
          panels.forEach(function (p) { p.style.display = p.getAttribute('data-tab-panel') === key ? '' : 'none'; });
          // For FAQ, also collapse open answers when switching tabs
          group.querySelectorAll('[data-faq-item].is-open').forEach(function (it) {
            if (!it.closest('[data-tab-panel="' + key + '"]')) it.classList.remove('is-open');
          });
          // For grid items with tag filter:
          items.forEach(function (item) {
            var tags = (item.getAttribute('data-tags') || '').split(',').map(function (s) { return s.trim().toLowerCase(); });
            var match = key === 'all' || tags.indexOf(key.toLowerCase()) !== -1;
            item.style.display = match ? '' : 'none';
          });
        });
      });
    });
  }

  // ─── Generic accordion (product page) ────────────────────────────────
  // Uses native <details>/<summary>. On open, closes sibling accordions.
  function initAccordions() {
    document.querySelectorAll('details.accordion').forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (!acc.open) return;
        var parent = acc.closest('.accordions');
        if (!parent) return;
        parent.querySelectorAll('details.accordion').forEach(function (other) {
          if (other !== acc) other.removeAttribute('open');
        });
      });
    });
  }

  // ─── Ritual step cards: tap-to-toggle on mobile ──────────────────────
  function initRitualSteps() {
    var steps = document.querySelectorAll('.ritual-step');
    steps.forEach(function (step) {
      step.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 767px)').matches) {
          var wasActive = step.classList.contains('is-active');
          steps.forEach(function (s) { s.classList.remove('is-active'); });
          if (!wasActive) step.classList.add('is-active');
        }
      });
    });
  }

  // ─── Product gallery thumbnails ──────────────────────────────────────
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.getAttribute('data-img-src');
        var alt = thumb.getAttribute('data-img-alt') || '';
        if (main && src) {
          var img = main.querySelector('img');
          img.srcset = '';
          img.src = src;
          img.alt = alt;
        }
      });
    });
  }

  // ─── Bundle radio (product page) ─────────────────────────────────────
  // Drives variant + qty selection for theme-rendered bundle cards.
  // UpsellKoala applies the actual cart-side discount; this handles UI + price display.
  function updateProductPurchaseState() {
    var purchaseWrap = document.querySelector('[data-product-purchase]');
    var bundleWrap = document.querySelector('[data-bundle]');
    var subscribeWrap = document.querySelector('[data-subscribe-purchase]');
    var qtyInput = document.querySelector('[data-product-qty]');
    var sellingPlanInput = document.querySelector('[data-selling-plan-input]');
    var displayPrice = document.querySelector('[data-display-price]');
    var displayCompare = document.querySelector('[data-display-compare]');
    if (!purchaseWrap) return;

    var option = bundleWrap ? bundleWrap.querySelector('[data-bundle-option].is-active') || bundleWrap.querySelector('[data-bundle-option]') : null;
    var basePrice = parseFloat((purchaseWrap && purchaseWrap.getAttribute('data-base-price')) || (bundleWrap && bundleWrap.getAttribute('data-base-price')) || '0');
    var qty = option ? parseInt(option.getAttribute('data-qty') || '1', 10) : 1;
    var bundleDiscount = option ? parseFloat(option.getAttribute('data-discount') || '0') : 0;
    var selectedPlan = subscribeWrap ? subscribeWrap.querySelector('[data-selling-plan-option].is-active') : null;
    var sellingPlanId = selectedPlan ? selectedPlan.getAttribute('data-selling-plan-id') : '';
    var discount = bundleDiscount;
    var total = basePrice * qty * (1 - discount);
    var compareTotal = basePrice * qty;

    if (qtyInput) qtyInput.value = qty;
    if (sellingPlanInput) {
      sellingPlanInput.value = '';
      sellingPlanInput.disabled = true;
    }
    if (displayPrice) displayPrice.textContent = formatMoney(total);
    if (displayCompare) {
      if (discount > 0) {
        displayCompare.textContent = formatMoney(compareTotal);
        displayCompare.style.display = '';
      } else {
        displayCompare.style.display = 'none';
      }
    }

    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.setAttribute('data-qty', btn.hasAttribute('data-purchase-subscribe') ? '1' : qty);
      btn.setAttribute('data-selling-plan', btn.hasAttribute('data-purchase-subscribe') ? sellingPlanId : '');
      if (option) btn.setAttribute('data-bundle-key', option.getAttribute('data-bundle-option'));
    });

    if (subscribeWrap) {
      subscribeWrap.classList.toggle('is-bundle-mode', qty !== 1);
      updateSubscribePurchaseDisplay(subscribeWrap, selectedPlan, basePrice);
    }
  }

  function initBundleRadio() {
    var wrap = document.querySelector('[data-bundle]');
    if (!wrap) {
      updateProductPurchaseState();
      return;
    }

    function selectBundle(option) {
      var qty = parseInt(option.getAttribute('data-qty'), 10);

      wrap.querySelectorAll('[data-bundle-option]').forEach(function (b) { b.classList.remove('is-active'); });
      option.classList.add('is-active');

      updateProductPurchaseState();
    }

    wrap.querySelectorAll('[data-bundle-option]').forEach(function (opt) {
      opt.addEventListener('click', function () { selectBundle(opt); });
    });
    updateProductPurchaseState();
  }

  // ─── Subscribe toggle ────────────────────────────────────────────────
  function initSubscribeToggle() {
    var wrap = document.querySelector('[data-subscribe-purchase]');
    if (!wrap) {
      updateProductPurchaseState();
      return;
    }
    var qtyInput = document.querySelector('[data-product-qty]');
    var sellingPlanInput = document.querySelector('[data-selling-plan-input]');

    wrap.querySelectorAll('[data-selling-plan-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        wrap.querySelectorAll('[data-selling-plan-option]').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        updateProductPurchaseState();
      });
    });

    var oneTime = wrap.querySelector('[data-purchase-onetime]');
    if (oneTime) {
      oneTime.addEventListener('click', function () {
        var activeBundle = document.querySelector('[data-bundle-option].is-active');
        var qty = activeBundle ? parseInt(activeBundle.getAttribute('data-qty') || '1', 10) : 1;
        if (qtyInput) qtyInput.value = qty;
        if (sellingPlanInput) {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      });
    }

    var subscribe = wrap.querySelector('[data-purchase-subscribe]');
    if (subscribe) {
      subscribe.addEventListener('click', function () {
        var selectedPlan = wrap.querySelector('[data-selling-plan-option].is-active');
        if (qtyInput) qtyInput.value = '1';
        if (sellingPlanInput && selectedPlan) {
          sellingPlanInput.value = selectedPlan.getAttribute('data-selling-plan-id') || '';
          sellingPlanInput.disabled = !sellingPlanInput.value;
        }
      });
    }

    updateProductPurchaseState();
  }

  function updateSubscribePurchaseDisplay(wrap, selectedPlan, basePrice) {
    if (!selectedPlan || !basePrice) return;

    var planName = selectedPlan.textContent.trim();
    var planPrice = parseFloat(selectedPlan.getAttribute('data-plan-price') || '0');
    var discountPercent = basePrice > 0 && planPrice > 0 ? Math.round((basePrice - planPrice) / basePrice * 100) : parseInt(wrap.getAttribute('data-discount-percent') || '0', 10);
    var annualSavings = Math.max(0, (basePrice - planPrice) * yearlyDeliveries(planName));

    var divider = wrap.querySelector('[data-subscribe-divider]');
    if (divider) {
      renderTemplateWithStrong(divider, wrap.getAttribute('data-divider-template') || '[percent]', '[percent]', discountPercent + '%');
    }

    var saving = wrap.querySelector('[data-annual-savings]');
    if (saving) {
      saving.textContent = (wrap.getAttribute('data-save-template') || '[amount]').replace('[amount]', formatMoney(annualSavings));
    }

    var title = wrap.querySelector('[data-subscribe-card-title]');
    if (title) {
      title.textContent = (wrap.getAttribute('data-subscribe-template') || '[frequency]').replace('[frequency]', planName);
    }

    var price = wrap.querySelector('[data-subscribe-card-price]');
    if (price) price.textContent = formatMoney(planPrice);

    var compare = wrap.querySelector('[data-subscribe-card-compare]');
    if (compare) compare.textContent = formatMoney(basePrice);
  }

  function yearlyDeliveries(planName) {
    var text = String(planName || '').toLowerCase();
    if (text.indexOf('3') !== -1 && (text.indexOf('week') !== -1 || text.indexOf('weken') !== -1)) return 52 / 3;
    if (text.indexOf('4') !== -1 && (text.indexOf('week') !== -1 || text.indexOf('weken') !== -1)) return 13;
    if (text.indexOf('30') !== -1 || text.indexOf('month') !== -1 || text.indexOf('maand') !== -1) return 12;
    return 12;
  }

  function renderTemplateWithStrong(el, template, token, value) {
    var parts = String(template || '').split(token);
    el.textContent = '';
    el.appendChild(document.createTextNode(parts[0] || ''));
    var strong = document.createElement('strong');
    strong.textContent = value;
    el.appendChild(strong);
    el.appendChild(document.createTextNode(parts.slice(1).join(token)));
  }

  function formatMoney(amount) {
    if (window.theme && window.theme.formatMoney) return window.theme.formatMoney(amount);
    return '€' + Number(amount).toFixed(2).replace('.', ',');
  }
  window.theme = window.theme || {};
  if (!window.theme.formatMoney) {
    window.theme.formatMoney = function (amount) {
      return '€' + Number(amount).toFixed(2).replace('.', ',');
    };
  }

  // ─── Init ────────────────────────────────────────────────────────────
  function init() {
    initFadeUp();
    initHeader();
    initMobileMenu();
    initFaqAccordions();
    initTabs();
    initAccordions();
    initRitualSteps();
    initProductGallery();
    initBundleRadio();
    initSubscribeToggle();

    // Hero stagger: kick off animation
    document.querySelectorAll('[data-hero-stagger]').forEach(function (h) {
      requestAnimationFrame(function () { h.classList.add('is-ready'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
